/* four — cart drawer (AJAX). Uses Shopify /cart.js, /cart/add.js, /cart/change.js */
(function () {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  var overlay = document.getElementById('cd-overlay');
  var body = document.getElementById('cd-body');
  var foot = document.getElementById('cd-foot');
  var subtotalEl = document.getElementById('cd-subtotal');
  var closeBtn = document.getElementById('cd-close');
  var fmt = (window.fourMoneyFormat || 'Rs {{amount}}');

  function formatMoney(cents) {
    var num = (cents / 100).toFixed(2);
    function withCommas(n, decimals) {
      var parts = parseFloat(n).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return decimals ? parts.join('.') : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount': return withCommas(num, 2);
        case 'amount_no_decimals': return withCommas(num, 0);
        case 'amount_with_comma_separator': return withCommas(num, 2);
        case 'amount_no_decimals_with_comma_separator': return withCommas(num, 0);
        default: return withCommas(num, 2);
      }
    });
  }

  function open() {
    overlay.hidden = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    document.documentElement.style.overflow = '';
  }

  function updateCount(n) {
    document.querySelectorAll('.nav__cart-count').forEach(function (el) { el.textContent = n; el.style.display = n > 0 ? '' : 'none'; });
    var cart = document.querySelector('.nav__cart');
    if (cart && n > 0 && !cart.querySelector('.nav__cart-count')) {
      var s = document.createElement('span'); s.className = 'nav__cart-count'; s.textContent = n; cart.appendChild(s);
    }
  }

  function lineItemHTML(it, i) {
    var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
    var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="cd-item__variant">' + it.variant_title + '</div>' : '';
    return '' +
      '<div class="cd-item" data-line="' + (i + 1) + '">' +
        '<a class="cd-item__img" href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="">' : '') + '</a>' +
        '<div class="cd-item__info">' +
          '<a class="cd-item__title" href="' + it.url + '">' + (it.product_title || it.title) + '</a>' +
          variant +
          '<div class="cd-item__row">' +
            '<div class="cd-qty">' +
              '<button type="button" class="cd-qty__btn" data-act="dec" aria-label="Decrease">&minus;</button>' +
              '<span class="cd-qty__n">' + it.quantity + '</span>' +
              '<button type="button" class="cd-qty__btn" data-act="inc" aria-label="Increase">+</button>' +
            '</div>' +
            '<span class="cd-item__price">' + formatMoney(it.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="cd-item__remove" data-act="remove">Remove</button>' +
        '</div>' +
      '</div>';
  }

  function render(cart) {
    updateCount(cart.item_count);
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cd-empty"><p>Your cart is empty.</p><a class="btn btn-out" href="/collections/all">Shop all pieces</a></div>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map(lineItemHTML).join('');
    subtotalEl.textContent = formatMoney(cart.total_price);
  }

  function req(url, payload) {
    return fetch(url, {
      method: payload ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: payload ? JSON.stringify(payload) : undefined
    }).then(function (r) { return r.json(); });
  }
  function getCart() { return req('/cart.js'); }
  function changeLine(line, qty) { return req('/cart/change.js', { line: line, quantity: qty }); }

  body.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-act]');
    if (!btn) return;
    var row = e.target.closest('.cd-item');
    if (!row) return;
    var line = parseInt(row.getAttribute('data-line'), 10);
    var act = btn.getAttribute('data-act');
    var cur = parseInt(row.querySelector('.cd-qty__n').textContent, 10);
    var next = act === 'remove' ? 0 : (act === 'inc' ? cur + 1 : cur - 1);
    if (next < 0) next = 0;
    drawer.classList.add('is-busy');
    changeLine(line, next).then(function (cart) { render(cart); drawer.classList.remove('is-busy'); });
  });

  document.querySelectorAll('.nav__cart').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); getCart().then(function (c) { render(c); open(); }); });
  });
  closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant');
    if (!id) return;
    var label = btn.textContent;
    btn.disabled = true; btn.classList.add('is-loading');
    req('/cart/add.js', { items: [{ id: parseInt(id, 10), quantity: 1 }] })
      .then(function (res) { if (res.status && res.status >= 400) { throw res; } return getCart(); })
      .then(function (c) { render(c); open(); btn.disabled = false; btn.classList.remove('is-loading'); })
      .catch(function () { btn.disabled = false; btn.classList.remove('is-loading'); btn.textContent = 'Sold out'; setTimeout(function () { btn.textContent = label; }, 1800); });
  });
})();
